<template>
  <div class="md-layout-item title-bread md-size-100">
    <div class="md-group pull-left title">
      AgBi - Cultivo: &nbsp;
    </div>
    <div class="md-group pull-left">
      <drop-down direction="down">
        <md-button slot="title" class="md-button md-info md-sm dropdown-toggle" data-toggle="dropdown">
          {{ cropSelected }}
        </md-button>
        <ul class="dropdown-menu dropdown-menu-left" >
          <li v-for="crop in cropsRegions" :key="crop"><a @click="changeSelectedCrop(crop)">{{crop}}</a></li>
        </ul>
      </drop-down>
    </div>
    <info-icon :message="info[0]"/>
    <div class="md-group pull-right options-web" v-if="marginsVisible">
      <md-button :class="buttonGroupClass(option)"
                 v-for="option in menuOptions" :key="option"
                 @click="changeSelectedOption(option)">{{option}}</md-button>
    </div>
    <div class="md-group pull-right options-mobile" v-if="marginsVisible">
      <drop-down direction="down">
        <md-button slot="title" class="md-button md-success md-sm dropdown-toggle" data-toggle="dropdown">
          {{ optionSelected }}
        </md-button>
        <ul class="dropdown-menu dropdown-menu-right" >
          <li v-for="option in menuOptions" :key="option"><a @click="changeSelectedOption(option)">{{option}}</a></li>
        </ul>
      </drop-down>
    </div>
  </div>
</template>

<script>

import InfoIcon from "../InfoIcon";
export default {
  name: 'regions-menu',
  components: {InfoIcon},
  props: ['cropSelected', 'cropsRegions', 'optionSelected', 'menuOptions', 'info' ],
  data() {
    return {
      marginsVisible: true,
    }
  },
  mounted() {
    window.addEventListener("scroll", () => {
      if(window.pageYOffset > 580)
        this.marginsVisible = false;
      else
        this.marginsVisible = true;
    },false);
  },
  computed: {},
  methods: {
    buttonGroupClass(option) {
      return (this.optionSelected == option) ? 'md-green md-sm active' : 'md-green md-sm';
    },
    changeSelectedCrop(crop) {
      this.$emit('update-selected-crop', crop);
    },
    changeSelectedOption(option) {
      this.$emit('update-selected-option', option);
    },
  }
}
</script>
<style>
  .title-bread{
    position:fixed;
    z-index: 500;
    left:0;
    right:0;
    border-radius: 0;
  }

  .md-button.md-green{
    background-color: #3a963d !important;
  }
  .md-button.md-green.active{
    background-color: #4caf50 !important
  }
  @media only screen and (min-width: 992px) {
    .options-mobile{
      display: none;
    }
    .options-web{
      display: block;
    }
  }
  @media only screen and (max-width: 992px) {
    .options-mobile{
      display: block;
    }
    .options-web{
      display: none;
    }
  }
  @media only screen and (max-width: 600px) {
    .title-bread .title {
      display: none !important;
    }
  }

</style>
